<template>
  <search-from :fields="fields" @click="onSearch" :pagination="pagination"></search-from>
</template>

<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import SearchFrom from "../base/SearchForm";
    import {SearchField} from "../../services/SearchField";
    import {PaginationMeta} from "../../models/PaginationMeta";

    const PeopleRepo = RepositoryFactory.get('people')

    export default {
      name: 'person-search-form',
      components: {
          SearchFrom,
      },
      props: {
        pagination: {
          type: Object,
          default: new PaginationMeta(),
        }
      },
      data() {
            return {
                fields: [
                  new SearchField()
                    .setLabel('Name')
                    .setDescription('Filter name.')
                    .setKey('name')
                    .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                  ,
                  new SearchField()
                    .setLabel('Email')
                    .setDescription('Filter Person Email.')
                    .setKey('email')
                    .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
                  ,
                ],
            }
        },
        methods: {
            onSearch(params) {
                this.$emit('click', params)
                PeopleRepo
                    .searchPeople(params)
                    .then(
                        response => (
                            this.$emit('change', response.data)
                        )
                    )
            },
        }
    }
</script>
